var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerticalDropdown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1332_7980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00032 2.66667C8.7367 2.66667 9.33365 2.06971 9.33365 1.33333C9.33365 0.596954 8.7367 0 8.00032 0C7.26394 0 6.66699 0.596954 6.66699 1.33333C6.66699 2.06971 7.26394 2.66667 8.00032 2.66667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00032 9.33365C8.7367 9.33365 9.33365 8.7367 9.33365 8.00032C9.33365 7.26394 8.7367 6.66699 8.00032 6.66699C7.26394 6.66699 6.66699 7.26394 6.66699 8.00032C6.66699 8.7367 7.26394 9.33365 8.00032 9.33365Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00032 15.9997C8.7367 15.9997 9.33365 15.4027 9.33365 14.6663C9.33365 13.93 8.7367 13.333 8.00032 13.333C7.26394 13.333 6.66699 13.93 6.66699 14.6663C6.66699 15.4027 7.26394 15.9997 8.00032 15.9997Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1332_7980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerticalDropdown);
export default __webpack_public_path__ + "static/media/vertical_dropdown.60327a7342dbf97fc59a9115cb5b96f7.svg";
export { ForwardRef as ReactComponent };